import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";

Vue.use(VueI18n);

// Each locales/<lang>/<namespace>.json file becomes the "<namespace>" key.
function loadMessages(context) {
  return context.keys().reduce((messages, file) => {
    const namespace = file.replace(/^\.\/(.*)\.json$/, "$1");
    messages[namespace] = context(file);
    return messages;
  }, {});
}

const en = loadMessages(require.context("@/locales/en", false, /\.json$/));
const fr = loadMessages(require.context("@/locales/fr", false, /\.json$/));

export const LANGUAGES = [
  { value: "en", title: "English", flag: require("@/assets/languages/English.svg") },
  { value: "fr", title: "Français", flag: require("@/assets/languages/French.svg") },
];

const DEFAULT_LOCALE = "en";
const STORAGE_KEY = "locale";

function isSupported(locale) {
  return LANGUAGES.some(({ value }) => value === locale);
}

function getSavedLocale() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return isSupported(saved) ? saved : DEFAULT_LOCALE;
  } catch (e) {
    return DEFAULT_LOCALE;
  }
}

// Things outside of vue-i18n that should follow the selected language.
function applyLocale(locale) {
  document.documentElement.lang = locale;
  axios.defaults.headers.common["Accept-Language"] = locale;
  if (Vue.prototype.$vuetify) Vue.prototype.$vuetify.lang.current = locale;
}

const i18n = new VueI18n({
  locale: getSavedLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { en, fr },
  silentFallbackWarn: true,
});

applyLocale(i18n.locale);

export function setLocale(locale) {
  if (!isSupported(locale)) return;
  i18n.locale = locale;
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch (e) {
    // ignore storage errors, the language still changes for this session
  }
  applyLocale(locale);
}

export default i18n;
